import { useCompare } from './useCompare'
import { getDifficultyLabel } from './compareSnapshot'

function createSessionCompareKey () {
  return 'cmp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9)
}

function fieldSignature (task) {
  if (!task) return ''
  return [
    task.title,
    task.description,
    task.qty,
    task.location
  ].join('\u0001')
}

export default {
  data: function () {
    return {
      compareChecked: false,
      sessionCompareKey: null,
      _compareFieldSignature: ''
    }
  },
  created: function () {
    this.sessionCompareKey = createSessionCompareKey()
    this._compareFieldSignature = this.buildCompareFieldSignature()
  },
  mounted: function () {
    const self = this
    this.$nextTick(function () {
      self._compareFieldSignature = self.buildCompareFieldSignature()
    })
  },
  computed: {
    compareMaxReached: function () {
      const compare = useCompare()
      return compare.isFull && !compare.isInCompare(this.sessionCompareKey)
    },
    compareCheckedInStore: function () {
      if (!this.sessionCompareKey || !this.$store || !this.$store.getters) return false
      const getter = this.$store.getters['compare/isInCompare']
      if (typeof getter !== 'function') return false
      return !!getter(this.sessionCompareKey)
    },
    compareCheckboxLabel: function () {
      if (this.compareMaxReached) return 'Compare (max 3 tasks)'
      return 'Compare'
    }
  },
  watch: {
    compareCheckedInStore: function (inStore) {
      // Keep modal checkbox in sync when drawer actions remove items (x / Clear all).
      this.compareChecked = !!inStore
    },
    'task.title': 'onCompareFieldsMaybeChanged',
    'task.description': 'onCompareFieldsMaybeChanged',
    'task.qty': 'onCompareFieldsMaybeChanged',
    'task.location': 'onCompareFieldsMaybeChanged'
  },
  methods: {
    getCompareSellPrice: function () {
      return this.price != null ? this.price : (this.task && this.task.sell_price)
    },
    getCompareMultipliers: function () {
      return (this.$store && this.$store.getters['task/getMultipliers']) || []
    },
    getCompareDifficultyLabel: function () {
      return getDifficultyLabel(this.task && this.task.location, this.getCompareMultipliers())
    },
    buildCompareFieldSignature: function () {
      return fieldSignature(this.task)
    },
    getCompareTask: function () {
      return this.task
    },
    preserveComparedVariantOnFieldChange: function () {
      return false
    },
    onCompareFieldsMaybeChanged: function () {
      const next = this.buildCompareFieldSignature()
      if (this._compareFieldSignature && next !== this._compareFieldSignature) {
        if (this.compareChecked && this.preserveComparedVariantOnFieldChange()) {
          this.compareChecked = false
          this.sessionCompareKey = createSessionCompareKey()
        } else {
          this.uncheckCompare()
        }
      }
      this._compareFieldSignature = next
    },
    onCompareCheckboxInput: function (checked) {
      const compare = useCompare()
      if (checked) {
        if (compare.isFull && !compare.isInCompare(this.sessionCompareKey)) {
          this.compareChecked = false
          return
        }
        compare.addToCompare(this.getCompareTask(), this.sessionCompareKey, {
          sellPrice: this.getCompareSellPrice(),
          multipliers: this.getCompareMultipliers(),
          difficultyLabel: this.getCompareDifficultyLabel()
        })
        this.compareChecked = true
      } else {
        compare.removeBySessionKey(this.sessionCompareKey)
        this.compareChecked = false
      }
    },
    uncheckCompare: function () {
      if (!this.compareChecked) return
      useCompare().removeBySessionKey(this.sessionCompareKey)
      this.compareChecked = false
    }
  }
}
